import styled from 'styled-components';

import {
  Flex,
} from 'web-styled';

export const Wrapper = styled(Flex).attrs({
  height: 'calc(100% - 50px)',
  width: '100%',
})`
  overflow: hidden;
  border-top: 1px solid rgba(40, 45, 48, 0.1);
`;
